import { render, staticRenderFns } from "./BookmarkManagement.vue?vue&type=template&id=290e7640&"
import script from "./BookmarkManagement.vue?vue&type=script&lang=js&"
export * from "./BookmarkManagement.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports